import { Alpine, Livewire } from '../../../vendor/livewire/livewire/dist/livewire.esm';

import ui from '@alpinejs/ui';
import numbermask from '../alpine/numbermask';
import autocomplete from './../alpine/autocomplete';
import dropdown from './../alpine/dropdown';
import siteSearch from './../alpine/site-search';
import select from './../alpine/select';
import toasts from './../alpine/toasts';
import initDisableBodyScroll from './disable-body-scroll';
import { focusNextElement } from './helpers';
import { registerOptionalUiComponents } from './optional-ui-components';
import initStepNavigation from './step-navigation';

/**
 * Initializes all UI components and starts AlpineJS
 * Has callbacks so you can run your code before
 * or after initializing components and before AlpineJS starts
 *
 * @returns {Promise<void>}
 * @param {function} beforeCallback
 * @param {function} afterCallback
 */
export default async function init(beforeCallback = null, afterCallback = null) {
    if (typeof beforeCallback === 'function') {
        beforeCallback();
    }

    initDisableBodyScroll();
    initStepNavigation();

    Alpine.data('autocomplete', autocomplete);
    Alpine.data('dropdown', dropdown);
    Alpine.data('siteSearch', siteSearch);
    Alpine.data('toasts', toasts);
    Alpine.data('select', select);
    Alpine.magic('focusNextElement', (el) => {
        focusNextElement(el);
    });

    Alpine.magic('numberMask', numbermask);
    await registerOptionalUiComponents(Alpine);

    Alpine.plugin(ui);

    if (typeof afterCallback === 'function') {
        afterCallback();
    }

    Alpine.magic('dialog', () => {
        return (modal, action, actionParams, content, title) => {
            const detail = {
                action,
                actionParams,
            };

            if (title) {
                detail.title = title;
            }

            if (content) {
                detail.content = content;
            }
            const event = new CustomEvent(
                `dialog-${modal}`,
                {
                    detail,
                });
            window.dispatchEvent(event);
        }
    })

    Livewire.start();
}
